import BaseApi from "./BaseApi";

export default class Dashboard extends BaseApi{
    construct() {}

    static async get(params) {
        return await Dashboard.getAxiosInstance().get(Dashboard.getApiUrl(),{params: params});
    }

    static async lastSeen(params) {
        return await Dashboard.getAxiosInstance().get(Dashboard.getApiUrl() + 'last_seen', {params:params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/dashboard/";
    }

}